"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcastWithAPI = void 0;
const logs_1 = require("@ledgerhq/logs");
const operation_1 = require("../../operation");
const errors_1 = require("./errors");
const broadcastWithAPI = ({ account, signedOperation, }, api) => __awaiter(void 0, void 0, void 0, function* () {
    const { signature, operation } = signedOperation;
    try {
        const txSignature = yield api.sendRawTransaction(Buffer.from(signature, "hex"));
        return (0, operation_1.patchOperationWithHash)(operation, txSignature);
    }
    catch (e) {
        // heuristics to make some errors more user friendly
        if (e instanceof Error) {
            (0, logs_1.log)("broadcast-error", e.message);
            if (e.message.includes("simulation failed") && account.pendingOperations.length > 0) {
                throw new errors_1.SolanaTxSimulationFailedWhilePendingOp();
            }
            if (e.message.includes("was not confirmed in")) {
                throw new errors_1.SolanaTxConfirmationTimeout();
            }
        }
        throw e;
    }
});
exports.broadcastWithAPI = broadcastWithAPI;
//# sourceMappingURL=js-broadcast.js.map